/* eslint-env browser */
import { Component, Input, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { HotelItem } from '@app/models/hotels/HotelItem';
import { CommonOffer } from '@app/models/offers/CommonOffer';
import { VerifyResponse } from '@app/models/offers/VerifyResponse';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { formatNumber } from '@angular/common';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '@app/services/encyption.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import moment from 'moment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PauschalDetailComponent } from '../offerpackdetailmodal/pauschal-detail/pauschal-detail.component';
import { TrafficsService } from '@app/services/traffics.service';

@Component({
    selector: 'app-offerpackpauschalcard',
    templateUrl: './offerpackpauschalcard.component.html',
    styleUrls: ['./offerpackpauschalcard.component.scss'],
    standalone: false
})
export class OfferpackpauschalcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    @Input() hotel: HotelItem;
    readonly index = input<number>(undefined);
    readonly reference = input<string>(undefined);
    readonly mode = input<string>(undefined);
    readonly offerid = input<string>(undefined);
    @Input() offer: CommonOffer;
    readonly currentCustomer = input<Customer>(undefined);
    @Input() booking: VerifyResponse;
    readonly categoryAr = input([]);
    readonly title = input<string>(undefined);
    readonly openSetComment = output<boolean>();
    readonly removeFromList = output<string>();
    readonly saveImagePos = output<number>();
    readonly changeindex = output<{
        dragedindex: number;
        dropindex: number;
    }>();

    checkloading: boolean = true;
    firstBilderPos: number = 0;
    desktopTemplate: string;
    travelerText: string = '';
    imgs: string[];
    partnerid: string = '';
    prcdetail: string = '';

    transferMessage: string = '';
    zugMessage: string = '';
    mwMessage: string = '';
    spMessage: string = '';
    wlMessage: string = '';
    showAlternative: boolean = false;

    component: ComponentRef<any>;

    sendRegSub: Subscription;
    sendBook: Subscription;
    showDetail: boolean = false;

    constructor(
        protected trafficsService: TrafficsService,
        protected dialog: MatDialog,
        protected encservice: EncryptionService,
        protected router: Router,
        protected guardService: AuthGuardService,
        protected cdr: ChangeDetectorRef,
        protected viewContainerRef: ViewContainerRef,
        protected mediaObserver: BreakpointObserver
    ) { }

    ngOnInit(): void {
        this.initMedia();
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.partnerid = partner?.partnerid;
            if (this.partnerid?.length > 0) {
                this.initData();
                this.checkOffer();
            }
        });
    }

    async checkOffer() {
        if (this.booking.commonOffer?.code?.length > 0) {
            this.checkloading = true;
            let childtrenages = '';
            let adults = 0;
            for (let i = 0; i < this.booking.travellerList?.length; i++) {
                if (this.booking.travellerList[i].type === 'K' || this.booking.travellerList[i].type === 'B') {
                    if (childtrenages?.length > 0) {
                        childtrenages += ',' + this.booking.travellerList[i].age;
                    } else {
                        childtrenages += this.booking.travellerList[i].age;
                    }
                } else {
                    adults++;
                }
            }

            const target = {
                data: {
                    code: this.booking.commonOffer.code,
                    adults: adults,
                    children: childtrenages,
                    rooms: '', // 3 rooms must be like : [{adults:2},{adults:1},{children:2}]
                    type: 'full',
                    optionAlternativeFlightOfferList: false,
                },
                mode: this.booking.mode,
                extra: this.booking.extra,
                insertOffer: true
            };

            this.trafficsService.request(target, 'offers/code').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.checkloading = false;
                const tmp_reference = this.booking.reference;
                if (!res.error) {
                    if (res.statusCode === 'OK' || res.statusCode === 'RQ') {
                        this.booking = res;
                        this.booking.reference = tmp_reference;
                    } else {
                        this.showAlternative = true;
                    }
                }
                this.initData();
                this.cdr.detectChanges();
            });
        }
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        this.sendRegSub?.unsubscribe();
        this.sendBook?.unsubscribe();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initData() {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.travellerList?.length; i++) {
            let prc = ''
            if (this.booking.travellerList[i].price?.value?.length > 0) {
                prc = formatNumber(Number(this.booking.travellerList[i].price?.value), 'de-DE', '1.2-2');
            } else {
                if (this.booking.travellerList[i].type === 'H') {
                    prc = formatNumber(Number(this.booking.pricePerPerson?.value), 'de-DE', '1.2-2');
                } else {
                    prc = '?';
                }
            }
            if (prc?.length > 0) {
                if (this.booking.travellerList[i].type === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR\n';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR\n';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.checkService();
        this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async checkService() {
        if (this.offer?.transferOffer?.code?.indexOf('MT') >= 0 || this.offer?.transferOffer?.code?.indexOf('TM') >= 0) {
            this.transferMessage = 'inkl. Transfer';
        }
        if (this.offer?.serviceOffer?.code?.indexOf('ZG') >= 0) {
            this.zugMessage = 'Zug zum Flug (innerhalb Deutschland)';
        }
        if (this.offer?.serviceOffer?.code?.indexOf('MW') >= 0) {
            this.mwMessage = 'inkl. Mietwagen';
        }
        if (this.offer?.serviceOffer?.code?.indexOf('SP') >= 0) {
            const i = this.offer.serviceOffer.code.indexOf('SP');
            this.spMessage = this.offer.serviceOffer.description.split(',')?.[i];
        }
        if (this.offer?.serviceOffer?.code?.indexOf('WL') >= 0) {
            this.wlMessage = 'inkl. Wellnessangebot';
        }
        this.cdr.detectChanges();
    }

    async goToBooking() {
        if (this.booking?.offerid?.length > 0) {
            const realparams = {
                offerid: this.booking?.offerid,
                productType: this.booking?.mode,
                reference: this.reference()?.length > 0 ? this.reference() : 'offerpack'
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['booking'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoOffers() {
        if (this.booking?.realparams) {
            let giata = this.booking.commonOffer?.hotelOffer?.hotel?.giata?.hotelId;
            if (!giata || Number(giata) === 0) {
                giata = this.booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code + '_' + this.booking.commonOffer?.hotelOffer?.hotel?.code;
            }
            this.booking.realparams.giataIdList = giata;
            this.booking.realparams.pauschalreiseResult.data.code = giata;
            if (this.booking.commonOffer?.flightOffer?.flight?.departureAirport?.code?.length > 0) {
                this.booking.realparams.airportsResult = [{
                    code: this.booking.commonOffer?.flightOffer?.flight?.departureAirport?.code,
                    name: this.booking.commonOffer?.flightOffer?.flight?.departureAirport?.name,
                }];
            }
            this.booking.realparams.reisezeitraumResult = {
                start: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.fromDate).format('YYYY-MM-DD'),
                end: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.toDate).format('YYYY-MM-DD'),
                minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
            };
            this.booking.realparams.reference = this.reference()?.length > 0 ? this.reference() : 'offerpack';
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(this.booking.realparams) }
            };
            const url = this.router.createUrlTree(['offers'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else if (this.booking?.offerid?.length > 0 && this.hotel?.giata?.hotelId?.length > 0) {
            let adults = 0;
            const children = [];
            let childrencount = 0;
            for (let i = 0; i < this.booking?.travellerList.length; i++) {
                if (this.booking?.travellerList[i].type === 'H') {
                    adults++;
                } else if (this.booking?.travellerList[i].type === 'K') {
                    childrencount++;
                    children.push({
                        age: this.booking?.travellerList[i].age,
                        children: childrencount
                    });
                }
            }
            let giata = this.booking.commonOffer?.hotelOffer?.hotel?.giata?.hotelId;
            if (!giata || Number(giata) === 0) {
                giata = this.booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code + '_' + this.booking.commonOffer?.hotelOffer?.hotel?.code;
            }
            const realparams = {
                giataIdList: giata,
                hotelCodeList: this.hotel?.code,
                pauschalreiseResult: {
                    data: {
                        code: giata,
                        name: this.hotel?.giata?.hotelName
                    },
                    type: 1
                },
                reisedauerResult: {
                    name: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration + ' Tage' : 'Beliebig',
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                reisezeitraumResult: {
                    start: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.fromDate).format('YYYY-MM-DD'),
                    end: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.toDate).format('YYYY-MM-DD'),
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                productType: this.booking.mode,
                reisendeResult: {
                    children: children,
                    adults: adults,
                },
                airportsResult: [{
                    code: this.booking.commonOffer?.flightOffer?.flight?.departureAirport?.code,
                    name: this.booking.commonOffer?.flightOffer?.flight?.departureAirport?.name,
                }]
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['offers'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            height: '100%',
            width: '100%',
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.hotel,
                images: this.hotel?.catalogData?.imageList,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((pos) => {
            if (pos !== this.firstBilderPos) {
                this.firstBilderPos = pos;
                this.saveImagesList(pos);
            }
        });
    }

    async setCommentModal() {
        this.openSetComment.emit(true);
    }

    saveImagesList(pos) {
        this.saveImagePos.emit(pos);
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(PauschalDetailComponent);
        this.component.instance.booking = this.booking;
        this.component.instance.hotel = this.hotel;
        this.sendRegSub = this.component.instance.sendAlt.subscribe((ev) => {
            if (ev) {
                this.gotoOffers();
            }
        });
        this.sendBook = this.component.instance.sendBook.subscribe((ev) => {
            if (ev) {
                this.goToBooking();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }
}
